import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ControlsModule } from "src/app/controls/controls.module";
import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "src/app/shared/shared.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { OnboardingComponent } from "./onboarding.component";
import { QuestionViewComponent } from "./question-view/question-view.component";
import { PremiumTrialComponent } from "./premium-trial/premium-trial.component";
import { BenefitViewComponent } from "./benefit-view/benefit-view.component";

@NgModule({
  declarations: [
    OnboardingComponent,
    QuestionViewComponent,
    PremiumTrialComponent,
    BenefitViewComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    SharedModule,
    ControlsModule,
    ReactiveFormsModule
  ],
  exports: [
    OnboardingComponent,
    PremiumTrialComponent
  ]
})
export class OnboardingModule { }